import axios from '@/libs/api.request'
import { CellGroup } from 'view-design'

//获取导航栏 
export const getNavlist = (params) => {
    return axios.request({
        url: "api.php/Index/nav",
        params,
        method: 'get'
    })
}

//首页数据
export const getHome = (params) => {
    return axios.request({
        url: "api.php/Index/index",
        params,
        method: 'get'
    })
}
//获取验证码
export const get_phonecode = (params) => {
    return axios.request({
        url: "api.php/Supplier/get_phonecode",
        params,
        method: 'get'
    })
}

//获取验证码
export const check_phonecode = (params) => {
    return axios.request({
        url: "api.php/Supplier/check_phonecode",
        params,
        method: 'get'
    })
}

//获取验证码
export const add_supplier = (params) => {
    return axios.request({
        url: "api.php/Supplier/add_supplier",
        params,
        method: 'get'
    })
}

//上传图片
export const upimage = (formData) => {
  console.log(formData, "图片上传");
  return axios.request({
    url: "api.php/Supplier/upimage",
    method: 'post',
    data: formData, // 使用 data 而不是 params
    headers: {
      'Content-Type': 'multipart/form-data' // 设置正确的请求头
    }
  });
}

//新闻列表
export const newsList = (route, params) => {

    return axios.request({
        url: `api.php/${route.c}/${route.a}`,
        params,
        method: 'get'
    })
}

//新闻详情
export const newsDetail = (route, params) => {
    return axios.request({
        url: `api.php/${route.c}/news_info`,
        params,
        method: 'get'
    })
}


//用户登录
export const supplier_username_login = (params) => {
    return axios.request({
        url: "api.php/Supplier/supplier_username_login",
        params,
        method: 'post'
    })
}

//用户登录退出
export const supplier_logout = (params) => {
    return axios.request({
        url: "api.php/Supplier/supplier_logout",
        params,
        method: 'post'
    })
}

//用户登录退出
export const supplier_info = (params) => {
    return axios.request({
        url: "api.php/Supplier/supplier_info",
        params,
        method: 'post'
    })
}

//招标列表
export const invite_list = (params) => {
    return axios.request({
        url: "api.php/Invite/invite_list",
        params,
        method: 'post'
    })
}

//招标详情
export const invite_info = (params) => {
    return axios.request({
        url: "api.php/Invite/invite_info",
        params,
        method: 'post'
    })
}

//招标详情
export const update_supplier = (params) => {
    return axios.request({
        url: "api.php/Supplier/update_supplier",
        params,
        method: 'post'
    })
}

export const develop_list = (params) => {
    return axios.request({
        url: "api.php/develop/develop_list",
        params,
        method: 'post'
    })
}